export default `
亮健康医生端隐私协议
提示条款 您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，亮健康医生平台服务提供者（或简称“亮健康医生”）制定本《隐私权政策》（下称“本隐私权政策”）并提醒您： 本政策适用于亮健康医生平台提供的所有产品和服务。如我们及关联公司（范围详见定义部分）的产品或服务中使用了亮健康医生提供的产品或服务（例如使用亮健康医生账户登录）但未设独立隐私权政策的，则本政策同样适用于该部分产品或服务。我们及关联公司就其向您提供的产品或服务单独设立有隐私权政策的，需要特别说明的是，本政策不适用于其他第三方向您提供的服务，第三方向您提供的服务适用其向您另行说明的隐私权政策。 在使用亮健康医生各项产品或服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。如对本政策内容有任何疑问、意见或建议，您可通过亮健康医生提供的各种联系方式与我们联系。
 一、定义 
亮健康医生：指亮健康医生客户端。 
亮健康服务提供者：湖南亮健优医易问网络科技有限公司 
个人信息： 指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 
个人敏感信息：指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息等的个人信息（我们将在本隐私权政策中对具体个人敏感信息以粗体进行显著标识）。 
个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。 
儿童：指不满十四周岁的未成年人。 除另有约定外，本政策所用定义与《亮健康平台服务协议》中的定义具有相同的涵义。

本应用尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。 

在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本应用服务使用协议不可分割的一部分。 

二、信息收集

1、以下将列举出亮健康医生所可能涉及收集的所有用户信息，但不代表本应用必然依据以下适用范围的全部内容进行信息收集，当且仅当您使用特定功能、服务时，相应的用户信息收集才将依照如下的使用方式和范围被触发，当您不需要使用特定功能、服务时，我们将不会进行信息收集。我们可能收集如下信息： 

1.1 个人信息：是可用于唯一地识别或联系某人的数据，如姓名、电子邮件地址、联系地址等，我们依据国家法律法规规定的“后台实名、前台自愿”原则，将对用户进行基于电话号码等方式进行真实身份信息认证所获取您的电话号码等信息。我们仅为实现以下目的而使用您主动向我们提交的个人信息：帮助我们开发、交付和改进本应用服务，从而使用户享受更优质的服务；管理您所参与的反馈、在线调查等活动。 

1.2 非个人信息：非个人信息是不会与任何特定个人直接相关联的数据。您在使用本应用服务时，系统可能通过cookies或其他方式自动采集的技术信息，包括但不限于您使用的设备或软件信息、URL、IP地址、浏览器类型、使用语言、访问日期和时间等。我们仅为实现以下目的而使用收集到的非个人信息：为了能更好的了解用户的行为，帮助用户解决本应用服务问题，改进本应用及其服务，并了解用户对本应用服务中的哪些部分最感兴趣。当您开启设备定位功能并使用我们基于位置提供的相关服务时，我们将收集的有关您位置的信息，包括但不限于通过GPS或WiFi等方式收集的您的地理位置信息，您或其他用户提供的包含您所处地理位置的实时信息等。您可以选择通过关闭定位功能，停止我们对您的地理位置信息的收集。 

1.3 敏感信息：某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的身份证号码、银行账号、种族、宗教、个人健康、医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。 

2、我们或我们的合作伙伴为提供更个性化的用户体验和服务，可能通过cookies收集和使用您的信息，并将该等信息储存为日志信息，并用于以下用途： 

2.1 记住您的身份。例如，cookie有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息； 

2.2 分析您使用我们服务的情况。例如，我们可利用cookies来了解您使用我们的服务进行什么活动，或哪些网页或服务最受您的欢迎； 

2.3 广告优化。例如，cookies有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。 

我们为上述目的使用cookies的同时，可能将通过cookies收集的非个人身份信息，经统计加工后提供给合作伙伴，用于分析用户如何使用我们的服务，并用于广告服务。我们的服务上可能会有广告商或其他合作伙伴放置的cookies。这些cookies可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies收集和使用该等信息，不受本《隐私政策》约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookies承担责任。 

3、我们仅在上述所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。 

二、信息使用

1、为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。我们可能将在向您提供服务的过程之中所收集的信息用作下列用途： 

1.1 向您提供服务； 

1.2 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的服务的安全性； 

1.3 帮助我们设计新服务，改善我们现有服务，提升用户体验，以向用户提供更好的服务； 

1.4 使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应； 

1.5 向您提供与您更加相关的广告以替代普遍投放的广告； 

1.6 评估我们服务中的广告和其他促销及推广活动的效果，并加以改善； 

1.7 软件认证或管理软件升级； 

1.8 让您参与有关我们产品和服务的调查； 

1.9 以预防、发现、调查存在欺诈、危害安全、非法或违反与本应用或其关联企业的协议、政策或规则的行为。 

2、除以下情形外，未经您同意，本应用不会向任何第三方提供您的用户信息： 

2.1 本应用可能会将您的个人信息和非个人信息提供给其关联企业、合作伙伴。因本应用提供服务所必需，本应用在提供您的敏感信息之前，将以明示方式征得您的同意。本应用将努力确保该等第三方在使用您的用户信息时遵守本《隐私政策》及其他适当的保密和安全措施。 

2.2 为遵守使用的法律法规、司法命令或其他相关政府机关的要求。 

2.3 为维护社会公共利益，保护本应用、其关联企业、其他用户的人身和财产安全或合法权益所合理必需的用途。 

2.4 随着亮健康医生业务的发展，本应用或其关联企业有可能进行合并、收购、资产转让或类似的交易，您的用户信息有可能作为此类交易的一部分而被转移。转移之后的公司可继续按法律规定和本《隐私政策》约定继续使用这些信息。 

三、信息披露

在如下情况下，亮健康医生将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息： 

1、经您事先同意，向第三方披露； 

2、为提供您所要求的产品和服务，而必须和第三方分享您的个人信息； 

3、根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露； 

4、如您出现违反中国有关法律、法规或者亮健康医生服务协议或相关规则的情况，需要向第三方披露； 

5、如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷； 

6、在亮健康医生平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。 

7、其它本应用根据法律、法规或者网站政策认为合适的披露。 

四、信息存储和交换

亮健康医生收集的有关您的信息和资料将保存在亮健康医生及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或亮健康医生收集信息和资料所在地的境外并在境外被访问、存储和展示。 

1、在使用亮健康医生服务过程中，亮健康医生对用户信息采用专业加密存储与传输方式，并运用各种安全技术和程序建立完善的管理制度来保护用户信息，以免遭受未经授权的访问、使用或披露。同时，为确保您的用户信息的安全，我们将公司的隐私和安全准则告知本应用雇员，并将在亮健康医生内部严格执行隐私保护措施。 

2、当出现下列非因我们过错而对您的信息造成泄露及由此造成的损害结果，我们无需承担任何责任： 

2.1 任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人资料泄露、丢失、被盗用或被篡改等。 

2.2 在使用亮健康医生服务的过程中链接到其它网站或因接受来自第三方的服务所造成之个人资料泄露及由此而导致的任何法律争议和后果。 

2.3 如您在使用亮健康医生服务（例如留言、评论等）的过程中主动公开、上传、发布或向第三方提供您的个人信息的，其他用户可能会收集您的个人信息，您应自行负责提交或分享的个人信息所造成的后果。 

2.4 我们的服务可能包括或链接至第三方提供的社交媒体或其他服务。例如，您可利用“分享”功能将某些内容分享到该等第三方社交媒体服务或其他服务，或您可利用第三方帐户登录我们的服务，这些功能可能会收集、共享您的信息（包括因cookies获取到的日志信息）。您使用该等第三方的社交媒体服务或其他服务，须受第三方自己的服务条款及隐私政策约束，您需要仔细阅读其条款。 

五、如何联系我们您可以通过以下方式与我们联系，我们将在15天内回复您的请求：1、如对本政策内容、儿童个人信息有任何疑问、意见或建议，您可通过淘亮健康在线客服与我们联系；2、如发现个人信息可能被泄露，您可以通过在线客服投诉举报；3、您可以通过其他方式与其联系。注册地址：湖南省长沙市芙蓉区定王台街道芙蓉中路二段88号定王大厦201常用办公地址:湖南省长沙市芙蓉区定王台街道芙蓉中路二段88号定王大厦201信息保护负责人联系电话0731-82578852如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。
六、本隐私政策的更改

1、如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。 

2、本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。 

为防止向第三方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。 

本《隐私政策》于2021年06月16日修订并生成`